var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":"/images/other/payment/zpay88Tutorial.jpg","width":"100%","usemap":"#image-map"}}),_c('map',{attrs:{"name":"image-map"}},[_c('area',{attrs:{"target":"","alt":"","title":"","href":"https://88pay.fun/","coords":"1776,525,1006,326","shape":"rect"}})])])
}]

export { render, staticRenderFns }